import React, { FC } from 'react';
import { calculateRotatedPivotedNodePos } from './KTileItem';
import { getKTileStyle, getPivotStyle } from './KTileAsset';
import KMeeple from './KMeeple';
import KNodeItem from './KNodeItem';
import KNode from '@envclient/envengine/src/envs/koenigsburg/KNode';
import { TaxPlacement } from '@envclient/envengine/src/envs/koenigsburg/KTile';

interface KTaxmanPhaseProps {
  active: boolean;
  taxableNodes: Map<number, TaxPlacement>;
  handleTaxClick: (cityTileId: number, node: KNode) => void;
}

const KTaxmanPhase: FC<KTaxmanPhaseProps> = ({ active, taxableNodes, handleTaxClick }) => {
  if (!active) return null;

  return (
    <>
      {Array.from(taxableNodes.entries()).map(([cityTileId, taxPlacement]) => {
        return taxPlacement.portNodes?.map((node) => {
          const tileStyle = getKTileStyle(node.tile.place);
          const left: number = +tileStyle.left.substring(0, tileStyle.left.length - 2);
          const top: number = +tileStyle.top.substring(0, tileStyle.top.length - 2);
          const pivotStyle = getPivotStyle(node.tile.place);
          const meepleRot = +pivotStyle.transform.match(/(\d+)/)?.[0] || 0;
          const nodeStyle = calculateRotatedPivotedNodePos(node, meepleRot, node.tile.rot, node.tile.shape, false);
          const meepleStyle = calculateRotatedPivotedNodePos(node, meepleRot, node.tile.rot, node.tile.shape, true);
          const contStyle = {
            left,
            top,
            position: 'absolute' as const
          };
          return (
            <div key={node.id} onClick={() => handleTaxClick(cityTileId, node)} style={contStyle}>
              <KNodeItem node={node} active={active} nodeStyle={nodeStyle} />
              {taxPlacement.selectedNode?.id === node.id && taxPlacement.selectedNode.meeple && (
                <KMeeple rotStyle={{}} meeple={taxPlacement.selectedNode.meeple} pos={meepleStyle} selected={true} />
              )}
            </div>
          );
        });
      })}
    </>
  );
};

export default KTaxmanPhase;
